var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            Enviar Notificações\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-row", [_c("b-col")], 1),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Título" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o título",
                                      state: _vm.isOk("title")
                                    },
                                    model: {
                                      value: _vm.state.title,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "title", $$v)
                                      },
                                      expression: "state.title"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("title")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Mensagem" } },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe a mensagem",
                                      state: _vm.isOk("message")
                                    },
                                    model: {
                                      value: _vm.state.message,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "message", $$v)
                                      },
                                      expression: "state.message"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("message")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        required: "",
                                        state: _vm.isOk("showPopup")
                                      },
                                      model: {
                                        value: _vm.state.showPopup,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "showPopup", $$v)
                                        },
                                        expression: "state.showPopup"
                                      }
                                    },
                                    [_vm._v("Mostrar em Popup")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("showPopup")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        required: "",
                                        state: _vm.isOk("sendAll")
                                      },
                                      model: {
                                        value: _vm.state.sendAll,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "sendAll", $$v)
                                        },
                                        expression: "state.sendAll"
                                      }
                                    },
                                    [_vm._v("Enviar para todos os usuários")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("sendAll")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Categoria da mensagem",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.state.categories,
                                      state: _vm.isOk("category")
                                    },
                                    model: {
                                      value: _vm.state.category,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "category", $$v)
                                      },
                                      expression: "state.category"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("category")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Perfil",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.state.selectedProfile,
                                          expression: "state.selectedProfile"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.state,
                                              "selectedProfile",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function($event) {
                                            return _vm.filterByProfile(
                                              _vm.state.selectedProfile
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione o perfil")]
                                      ),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "" } }),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "consumer" } },
                                        [_vm._v("Consumidor")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "trader" } },
                                        [_vm._v("Comercializador")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "investor" } },
                                        [_vm._v("Investidor")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    class: {
                                      "is-invalid": !_vm.isOk("profile")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isOk("profile") === false
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(_vm._s(_vm.getError("profile")))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Seleção de usuários",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.state.clientsFiltered,
                                      disabled: _vm.state.sendAll,
                                      multiple: true
                                    },
                                    model: {
                                      value: _vm.state.selectedUsers,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.state,
                                          "selectedUsers",
                                          $$v
                                        )
                                      },
                                      expression: "state.selectedUsers"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.send(),
                                  label: "Enviar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }